import { useLoginUserMutation } from "Data/services/userAuthApi";
import { getErrorMessage } from "Hooks/useErrorHandler";
import { ErrorToast, SuccessToast } from "Hooks/useToast";
import React, { useEffect } from "react";
import { Form, InputGroup, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Button, Input, SubTitle } from "../../Components/CustomComponents";
import AccountLayout from "../../Components/Layouts/AccountLayout";
import { WEB_ROUTES } from "../../constants";
import { storeToken } from "../../Data/services/localStorageService";

interface LoginProps {
  setPage?: React.Dispatch<React.SetStateAction<string>>;
}

export interface LoginFormData {
  username: string;
  password: string;
  device_type: string;
  device_token: string;
}

const Login: React.FC<LoginProps> = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<LoginFormData>({
    mode: "onChange",
    defaultValues: {
      username: "",
      password: "",
      device_type: "234",
      device_token: "android",
    },
  });
  const navigate = useNavigate();

  const [loginUser, { isLoading }] = useLoginUserMutation();

  useEffect(() => {
    if (errors.username?.message) {
      ErrorToast(errors.username.message as string);
    }
    if (errors.password?.message) {
      ErrorToast(errors.password.message as string);
    }
  }, [errors.username?.message, errors.password?.message]); // Trigger when errors change

  const handleLogin = async (data: LoginFormData) => {
    data["device_type"] = "web";
    data["device_token"] = "123123";
    try {
      const response = await loginUser(data).unwrap();

      if (response.code !== 200) {
        ErrorToast(response.message);
      }

      if (response.code === 200) {
        storeToken(response.data.api_token);
        navigate(WEB_ROUTES.HOME);
        SuccessToast(response.message);
      }
    } catch (error: unknown) {
      // console.log("Login Error:", error);
      ErrorToast(getErrorMessage(error));
    }
  };

  return (
    <AccountLayout>
      {
        // <Title text="Welcome to" classes="mb-2 fs-4" />
      }
      <SubTitle text="Login to Your Account" classes="mb-5 fs-2" />
      {/* <InstalledButton /> */}
      <Form onSubmit={handleSubmit(handleLogin)} className="w-100">
        <Controller
          control={control}
          name="username"
          rules={{
            required: "Username or Phone is required.",
          }}
          render={({ field: { onChange, value } }) => (
            <InputGroup
              className="mb-3 w-100"
              style={{
                width: "300px",
              }}
            >
              <Input
                placeholder="Username or Phone Number"
                type="text"
                value={value}
                onChange={onChange}
              />
            </InputGroup>
          )}
        />
        <Controller
          control={control}
          name="password"
          rules={{
            required: "Password is required.",
            minLength: {
              value: 3,
              message: "Minimum 3 characters long.",
            },
          }}
          render={({ field: { onChange, value } }) => (
            <InputGroup
              className="mb-3 w-100"
              style={{
                width: "300px",
              }}
            >
              <Input
                type="password"
                placeholder="Passwords"
                value={value}
                onChange={onChange}
              />
            </InputGroup>
          )}
        />
        <Button
          text={
            isLoading ? (
              <Spinner animation="border" variant="light" size="sm" />
            ) : (
              "Login"
            )
          }
          classes="mt-3 mb-2 blueBtnBg"
          type="submit"
          disabled={isLoading}
          // onClick={handleLogin}
        />
      </Form>
      {/* <Description
        classes="ms-auto cursor-pointer"
        text="Forgot Password ?"
        onClick={handleForgotPasswordClick}
      /> */}
    </AccountLayout>
  );
};

export default Login;
